import * as types from './actionTypes';
import getAPIPath from '../../js/modules/api-location';
import { addNotification } from './notificationActions';

export function loadSessionSuccess(session) {
  return { type: types.LOAD_SESSION_SUCCESS, session };
}

export function deleteSessionSuccess(contentId) {
  return { type: types.DELETE_FROM_CONTENT_LIST_SUCCESS, contentId };
}

export function loadSession(contentId) {
  return function(dispatch) {
    // If we are loading an individual session (an ID will exist)
    return fetch(`${getAPIPath}queryapi/session/${contentId}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then((response) => {
      response.json().then((session) => {
        dispatch(loadSessionSuccess(session.data));
      });
    }).catch((error) => {
      throw (error);
    });
  };
}

export function deleteSession(contentId) {
  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/session/${contentId}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        Accept: 'application/json',
      },
    })
    .then(response => response.json().then(() => {
      dispatch(deleteSessionSuccess(contentId));
      dispatch(addNotification({
        message: 'Successfully deleted',
        level: 'success',
        autoDismiss: 3,
        dismissible: 'click',
      }));
    }))
    .catch((error) => {
      throw (error);
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/sessionActions.js